import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Card, CardContent, CardHeader, Grid } from '@mui/material';
import PresentTextField from '../../../../components/inputs/PresentTextField';

const styles = {
  card: {
    marginBottom: '1.5rem'
  },
  inputWrapper: {
    paddingX: '0.5rem'
  },
}

const EmployeeDetailsForm = () => {
  const [employee, setEmployee] = useState({
    _id: '',
    identityNumber: '',
    identityNumberExpedition: '',
    name: '',
    firstLastName: '',
    secondLastName: '',
    address: '',
    city: '',
    fixedPhoneNumber: '',
    mobilePhoneNumber: '',
    birthdate: '',
    birthplace: '',
    gender: '',
    citizenship: '',
  });

  const current = useSelector(state => state.employees.current);
    
  useEffect(() => setEmployee({
    ...employee,
    ...current,
    birthdate: current?.birthdate?.slice(0, 10) ?? '',
    identityNumberExpedition: current?.identityNumberExpedition?.slice(0, 10) ?? ''
  }), [current]);

  return (
    <Card sx={styles.card}>
      <CardHeader title="Datos del empleado" />
      <CardContent>
        <Grid container>
          <Grid item xs={12} md={4} sx={styles.inputWrapper}>
            <PresentTextField label="Nombre" name="name" value={employee.name} />
          </Grid>
          <Grid item xs={12} md={4} sx={styles.inputWrapper}>
            <PresentTextField label="Primer apellido" name="firstLastName" value={employee.firstLastName} />
          </Grid>
          <Grid item xs={12} md={4} sx={styles.inputWrapper}>
            <PresentTextField label="Segundo apellido" name="secondLastName" value={employee.secondLastName} />
          </Grid>
          <Grid item xs={12} md={6} sx={styles.inputWrapper}>
            <PresentTextField label="Número de identidad" name="identityNumber" value={employee.identityNumber} />
          </Grid>
          <Grid item xs={12} md={6} sx={styles.inputWrapper}>
            <PresentTextField label="Fecha de expedición de número de identidad" type="date" InputLabelProps={{ shrink: true }} name="identityNumberExpedition" value={employee.identityNumberExpedition} />
          </Grid>
          <Grid item xs={12} md={12} sx={styles.inputWrapper}>
            <PresentTextField label="Dirección" name="address" value={employee.address} />
          </Grid>
          <Grid item xs={12} md={6} sx={styles.inputWrapper}>
            <PresentTextField label="Teléfono fijo" name="fixedPhoneNumber" value={employee.fixedPhoneNumber} />
          </Grid>
          <Grid item xs={12} md={6} sx={styles.inputWrapper}>
            <PresentTextField label="Teléfono móvil" name="mobilePhoneNumber" value={employee.mobilePhoneNumber} />
          </Grid>
          <Grid item xs={12} md={6} sx={styles.inputWrapper}>
            <PresentTextField label="Fecha de nacimiento" type="date" InputLabelProps={{ shrink: true }} name="birthdate" value={employee.birthdate} />
          </Grid>
          <Grid item xs={12} md={6} sx={styles.inputWrapper}>
            <PresentTextField label="Lugar de nacimiento" name="birthplace" value={employee.birthplace} />
          </Grid>
          <Grid item xs={12} md={6} sx={styles.inputWrapper}>
            <PresentTextField label="Ciudadanía" name="citizenship" value={employee.citizenship} />
          </Grid>
          <Grid item xs={12} md={6} sx={styles.inputWrapper}>
           <PresentTextField label="Género" name="gender" value={employee.gender} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default EmployeeDetailsForm;

